import type { RouteRecordRaw } from 'vue-router'
import IconQuestionnaires from '@/components/icons/IconQuestionnaires.vue'

const spencerAdminRoutesNames = {
  spencerAdminSchools: 'spencerAdminSchools',
  spencerAdminQuestionnaires: 'spencerAdminQuestionnaires',
  spencerAdminCreateSchool: 'spencerAdminCreateSchool',
  spencerAdminProfileSettings: 'spencerAdminProfileSettings',
  spencerAdminEditSchool: 'spencerAdminEditSchool',
  spencerAdminQuestionnairesList: 'spencerAdminQuestionnairesList',
  spencerAdminThemeList: 'spencerAdminThemeList',
  spencerAdminRecommendations: 'spencerAdminRecommendations'
}

const spencerAdminRoutes: RouteRecordRaw[] = [
  {
    path: 'schools',
    name: spencerAdminRoutesNames.spencerAdminSchools,
    meta: {
      label: 'Schools',
      icon: PhBuildings
    },
    component: () => import('@/views/spencer-admin/school/SpencerAdminSchools.vue')
  },
  {
    path: 'schools/create',
    name: spencerAdminRoutesNames.spencerAdminCreateSchool,
    meta: {
      parentName: spencerAdminRoutesNames.spencerAdminSchools,
      notRenderInSidebar: true
    },
    component: () => import('@/views/spencer-admin/school/SpencerAdminSchoolDetails.vue')
  },
  {
    path: 'schools/:id',
    name: spencerAdminRoutesNames.spencerAdminEditSchool,
    meta: {
      parentName: spencerAdminRoutesNames.spencerAdminSchools,
      notRenderInSidebar: true
    },
    component: () => import('@/views/spencer-admin/school/SpencerAdminSchoolDetails.vue')
  },
  {
    path: 'questionnaires',
    name: spencerAdminRoutesNames.spencerAdminQuestionnaires,
    meta: {
      label: 'Questionnaires',
      icon: IconQuestionnaires,
      routeTestId: 'spencer-admin-questionnaires-route-btn'
    },
    redirect: { name: spencerAdminRoutesNames.spencerAdminQuestionnairesList },
    component: () => import('@/layouts/RouterTabsLayout.vue'),
    children: [
      {
        path: 'list',
        name: spencerAdminRoutesNames.spencerAdminQuestionnairesList,
        component: () => import('@/views/spencer-admin/questionnaires/SpencerAdminQuestionnaires.vue'),
        meta: {
          parentName: spencerAdminRoutesNames.spencerAdminQuestionnaires,
          label: 'Questionnaires',
          icon: PhQuestion,
          routeTestId: 'spencer-admin-questionnaires-list-tab'
        }
      },
      {
        path: 'theme-list',
        name: spencerAdminRoutesNames.spencerAdminThemeList,
        component: () => import('@/views/spencer-admin/questionnaires/SpencerAdminThemeList.vue'),
        meta: {
          parentName: spencerAdminRoutesNames.spencerAdminQuestionnaires,
          label: 'Theme List',
          icon: PhSquareLogo,
          routeTestId: 'spencer-admin-themes-list-tab'
        }
      },
      {
        path: 'recommendations',
        name: spencerAdminRoutesNames.spencerAdminRecommendations,
        component: () => import('@/views/spencer-admin/questionnaires/SpencerAdminRecommendations.vue'),
        meta: {
          parentName: spencerAdminRoutesNames.spencerAdminQuestionnaires,
          label: 'Recommendations',
          icon: PhFileLock,
          routeTestId: 'spencer-admin-recommendations-list-tab'
        }
      }
    ]
  }
]

export {
  spencerAdminRoutesNames,
  spencerAdminRoutes
}
